import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PdfModalComponent } from './PdfModalComponent';
import initialActions from 'actions/initialActions';

const mapStateToProps = state => ({
    pdfFile: state.initialStep.get('pdfDownloadLink'),
});

const mapDispatchToProps = dispatch => ({
    initialActions: bindActionCreators(initialActions, dispatch),
});

export const PdfModal = connect(mapStateToProps, mapDispatchToProps)(PdfModalComponent);
